import React, { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@apollo/client';
import { getOrderDetailsTemplate } from 'apollo/templates/order';
import { Order } from 'models/order';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { useTranslation } from 'react-i18next';
import WorkflowActions from './workflow-actions.component';

type WorkflowActionsDialogProps = {
    open: boolean;
    orderId?: string;
    onClose: () => void;
    onStepChanged?: () => void;
};

const WorkflowActionsDialog: FC<WorkflowActionsDialogProps> = ({ open, orderId, onClose, onStepChanged }) => {
    const { t: translate } = useTranslation(['workflow']);
    const { showBoundary } = useDenthubErrorBoundary();
    // Read fresh on open, then from the cache: the workflow mutations return the Order, so
    // Apollo updates this view itself (DD-3231).
    const { data, loading } = useQuery(getOrderDetailsTemplate, {
        variables: { orderId },
        skip: !open || !orderId,
        fetchPolicy: 'network-only',
        onError: (error) => showBoundary(error),
    });
    const order: Order | undefined = data?.order;

    return (
        <DHDialog open={open} onClose={onClose} maxWidth="sm" fullWidth title={translate('workflow:WORKFLOW')}>
            {loading || !order ? (
                <Box display="flex" justifyContent="center" py={4}>
                    <CircularProgress />
                </Box>
            ) : (
                <WorkflowActions order={order} onCompleted={onStepChanged} />
            )}
        </DHDialog>
    );
};

export default WorkflowActionsDialog;
